import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { GameOptions } from '../../config';
import useColors from '../../hooks/useColors';
import useLeaderboardData from '../../hooks/useLeaderboardData';
import languages, { DEFAULT_LANGUAGE } from '../../languages';
import { flattenMessages } from '../../utils/flattenMessages';
import { GameTypeFilters, Header, ScoreTable } from '../partials';
import NoResultsMessage from '../partials/NoResultsMessage';
var LEADERBOARD_ID = 'game-leaderboard-container';
export default function GameLeaderboard(_a) {
    var endpoint = _a.endpoint, forceGameType = _a.forceGameType, _b = _a.theme, theme = _b === void 0 ? 'light' : _b, _c = _a.showCountryFlags, showCountryFlags = _c === void 0 ? false : _c, _d = _a.showFilters, showFilters = _d === void 0 ? true : _d, renderAdditionalFilters = _a.renderAdditionalFilters, className = _a.className, apiToken = _a.apiToken, language = _a.language, refreshInterval = _a.refreshInterval, colors = _a.colors, _e = _a.hideResults, hideResults = _e === void 0 ? false : _e, _f = _a.activeRound, activeRound = _f === void 0 ? 1 : _f, _g = _a.showHeader, showHeader = _g === void 0 ? true : _g, _h = _a.enableToggleScoreSheets, enableToggleScoreSheets = _h === void 0 ? true : _h, _j = _a.units, units = _j === void 0 ? 'metric' : _j, isWeekly = _a.isWeekly, timezone = _a.timezone, verifyScores = _a.verifyScores, gameOptions = _a.gameOptions;
    var _k = useState(forceGameType || GameOptions.PRIMARY), gameType = _k[0], setGameType = _k[1];
    var _l = useLeaderboardData(endpoint, apiToken, refreshInterval), data = _l.data, loading = _l.loading;
    useColors(LEADERBOARD_ID, colors === null || colors === void 0 ? void 0 : colors.primary, colors === null || colors === void 0 ? void 0 : colors.secondary);
    var handleGameTypeChange = function (gameType) {
        setGameType(gameType);
    };
    var getScoreData = function () {
        return data === null || data === void 0 ? void 0 : data[gameType];
    };
    var getHeaderData = function () {
        if (data && data.rounds.length > 0) {
            var roundIndex = data.rounds[activeRound - 1] ? activeRound - 1 : 0;
            var round = data.rounds[roundIndex];
            return {
                gameName: data.name,
                clubName: round.clubName,
                courseName: round.courseName,
                par: round.parTotal,
                date: (round === null || round === void 0 ? void 0 : round.startTime) ? round === null || round === void 0 ? void 0 : round.startTime : round === null || round === void 0 ? void 0 : round.legacyDate,
                units: units,
                timezone: timezone
            };
        }
        return;
    };
    var getContainerClasses = function () {
        var baseClass = LEADERBOARD_ID;
        return className ? "".concat(baseClass, " ").concat(className) : baseClass;
    };
    var getLanguage = function () {
        return language || DEFAULT_LANGUAGE;
    };
    useEffect(function () {
        forceGameType && setGameType(forceGameType);
    }, [forceGameType]);
    var renderScoreTableOrShowMessage = function () {
        if (hideResults) {
            return React.createElement(NoResultsMessage, { id: "leaderboard.resultsNotPublished" });
        }
        var noResults = !loading && (data === null || (data === null || data === void 0 ? void 0 : data.rounds.length) === 0);
        if (noResults) {
            return React.createElement(NoResultsMessage, { id: "leaderboard.empty" });
        }
        return (React.createElement("div", { className: "overflow-auto" },
            React.createElement(ScoreTable, { leaderboard: data, game: getScoreData(), showCountryFlags: showCountryFlags, isLoading: loading, isScratch: gameType === GameOptions.SCRATCH, enableToggleScoreSheets: enableToggleScoreSheets, units: units, isWeekly: isWeekly, timezone: timezone, verifyScores: verifyScores })));
    };
    return (React.createElement(IntlProvider, { locale: getLanguage(), messages: flattenMessages(languages[getLanguage()]) },
        React.createElement("div", { "data-theme": theme, className: getContainerClasses(), id: LEADERBOARD_ID },
            showFilters && (React.createElement(GameTypeFilters, { leaderboard: data, handleChange: handleGameTypeChange, renderAdditionalFilters: renderAdditionalFilters, currentGameType: gameType, gameOptions: gameOptions })),
            React.createElement("div", { className: "leaderboard-container" },
                showHeader && React.createElement(Header, { data: getHeaderData() }),
                renderScoreTableOrShowMessage()))));
}
